import { render, staticRenderFns } from "./UtilPagination.vue?vue&type=template&id=6c2586f5"
import script from "./UtilPagination.vue?vue&type=script&lang=js"
export * from "./UtilPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports